<template>
  <div>
    <BusinessCard
      packUp
      identity="unLoginShare"
      :cardDetail="cardDetail"
      :cooperationDetail="cooperationDetail"
      @login="handleLogin"
    />
    <!-- :isLoading="isLoading" -->
  </div>
</template>

<script>
import BusinessCard from "@supplier/base/BusinessCard";
import { mapGetters } from "vuex";

export default {
  inject:{
    unLogin: {
      default: false
    }
  },
  components: {
    BusinessCard
  },
  props: {},
  data() {
    return {
      isLoading: false
    };
  },
  computed: {
    ...mapGetters(['shareCompanyInfo']),
    cardDetail() {
      if(this.shareCompanyInfo) {
        return this.shareCompanyInfo
      } else {
        return {
          companyName: '',
          majorCategory: '',
          wx: '',
          phone: '',
          vipMark: false,
          distributionPlatform: [],
          majorPlatform: [],
          video: [],
          picture: [],
          summary: ''
        }
      }
    },
    cooperationDetail() {
     if(this.shareCompanyInfo && this.shareCompanyInfo.supplyAbilityInfo) {
       return this.shareCompanyInfo.supplyAbilityInfo
     } else {
       return {
        cooperationMode: [], // 合作模式 1: 一件代发、 2:批量采购 - 可多选，逗号分隔
        deliveryTime: 1
      }
     }
    }
  },
  methods: {
    handleLogin(){
      this.$emit('login')
    }
  }
};
</script>

<style scoped>
</style>
